import api from '@/config/api'
const catchErrors = {
  get: async (url, options) => {
    const resp = await api.get(url, options)
    if (!resp) throw new Error(`[GET] No response from server: ${url}`)
    if (resp.data?.errors) {
      if (resp.data.errors[0].detail) {
        throw new Error(resp.data.errors[0].detail)
      } else throw new Error(JSON.stringify(resp.data.errors))
    }
    return resp
  },
  post: async (url, payload, options) => {
    const resp = await api.post(url, payload, options)
    if (!resp) throw new Error(`[POST] No response from server: ${url}`)
    if (resp.data?.errors) {
      if (resp.data.errors[0].detail) {
        throw new Error(resp.data.errors[0].detail)
      } else throw new Error(JSON.stringify(resp.data.errors))
    }
    return resp
  },
  patch: async (url, payload, options) => {
    const resp = await api.patch(url, payload, options)
    if (!resp) throw new Error(`[PATCH] No response from server: ${url}`)
    if (resp.data?.errors) {
      if (resp.data.errors[0].detail) {
        throw new Error(resp.data.errors[0].detail)
      } else throw new Error(JSON.stringify(resp.data.errors))
    }
    return resp
  },
  delete: async (url, options) => {
    const resp = await api.delete(url, options)
    if (!resp) throw new Error(`[DELETE] No response from server: ${url}`)
    if (resp.data?.errors) {
      if (resp.data.errors[0].detail) {
        throw new Error(resp.data.errors[0].detail)
      } else throw new Error(JSON.stringify(resp.data.errors))
    }
    return resp
  }
}

export default catchErrors
